import React, { useState } from "react";
import "./ImportCSV.css";
import TemplateSetting from "../../../API/APIServices/TemplateSetting";
import Loader from "../../Props/Loader";

const CSVModal = ({ onClose, MasterType }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLensProduct, setisLensProduct] = useState(false);
  const ChangeIsLens = (e) => {
    setisLensProduct(e.target.value);
  };
  const [csvData, setCsvData] = useState(null);
  const [csvFile, setCsvfile] = useState(null);
  const [showSuccess, setshowSuccess] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setCsvfile(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const rows = text.split("\n").map((row) => row.split(","));
        setCsvData(rows);
      };
      reader.readAsText(file);
    }
  };

  const handleClose = () => {
    setCsvData(null);
    onClose();
  };

  const handleCSVUpload = async (e) => {
    try {
      setIsLoading(true);
      ;
      const data = await TemplateSetting.ImportStaticCSVExcelFile(
        csvFile,
        isLensProduct
      );
      console.log(data);
      if (data.isSuccess) {
        setshowSuccess(true);
        setIsLoading(false);
        // setTimeout(() => {
        //   onClose(false);
        // }, 1500);
      } else {
        alert(data.result);
        setIsLoading(false);
      }
    } catch (error) {
      alert("Failed to upload CSV file!");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ color: "white" }}>
        <span
          className="close"
          style={{ top: "-10px", right: "5px" }}
          onClick={handleClose}
        >
          &times;
        </span>
        {/* <h4>Upload CSV File</h4> */}
        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>
          <h4>Upload CSV File</h4>
          <button
            onClick={() =>
              (window.location.href = "/eCom Excel Data Import.xlsx")
            }
          >
            Download CSV
          </button>
        </div>

        <div className="form-group">
          <label style={{ marginRight: "10px" }}>Select CSV file:- </label>
          <input
            type="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileChange}
            style={{
              margin: "10px 0",
              left: "30px",
              cursor: "pointer",
              height: "45px",
            }} // Add your desired styles here
          />
            <label style={{ marginRight: "10px" }}>Is lens Product :- </label>
            
            <select
              name=""
              id=""
              onChange={(e) => ChangeIsLens(e)}
              value={isLensProduct}
            >
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
        </div>
        {showSuccess && (
          <span className="upload-message">CSV file uploaded</span>
        )}
        <button onClick={handleCSVUpload}>Upload CSV</button>
      </div>
      {isLoading && <Loader />}
    </div>
  );
};

export default CSVModal;
